module.exports = __webpack_public_path__ + "img/logo-black.c9e9c91c.png";